import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { massUpdateActions } from 'constants/MassUpdates';
import { REGIONS } from 'constants/Regions';
import { isProd } from 'helpers/helper_functions';
import React, { useMemo, useState } from 'react';
import { Menu } from '@headlessui/react';
import { firstLetterTitlization } from 'utils/localization/utils';
import BulkEditModal from 'components/modules/shipments/MassUpdateModal';
import ChangeUserModal from 'components/modules/shipments/ChangeUserModal';
import BulkUpdateSendDOModal from 'components/modules/shipments/BulkUpdateSendDOModal';
import BulkUpdateCarrierCostModal from 'components/modules/shipments/BulkUpdateCarrierCostModal';
import BulkAddAccessorialsModal from 'components/modules/shipments/accounting/BulkAddAccessorialsModal';
import BulkGenerateRateConfirmation from 'components/modules/shipments/BulkGenerateRateConfirmationModal';
import DropdownItem from 'components/v2/dropdowns/DropdownItem';
import DropdownMenu from 'components/v2/dropdowns/DropdownMenu';

import BulkAddYardsModal from 'components/modules/yards/BulkAddYardsModal';
import AssignDriverModal from 'components/modules/shipments/AssignDriverModal';
import { ConfirmationModal } from 'components/v2/confirmation-modal';
import {
  evaluateBillingStatus,
  bulkCloseJobs,
} from 'utils/ShipmentWebAPIUtils';
import useModal from 'hooks/useModal';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import { useTranslation } from 'react-i18next';
import { Alert } from '@cargomatic/ui';
import { showToast } from 'stores/ToastStore';
import SessionStore from 'stores/SessionStore';
import BulkBOLGenerationModal from '../shipments/BulkBOLGenerationModel';
import ConfirmAssignCarrierModal from '../shipments/ConfirmAssignCarrierModal';
import { OverrideBillingStatusModal } from '../shipments/OverrideBillingStatusModal';
import { BillingStatusPendingReviewModal } from '../shipments/BillingStatusPendingReviewModal';
import BulkUploadDocumentsModel from '../shipments/BulkUploadDocumentsModel';
import { PENDING_REVIEW } from 'constants/billing-status';
import _ from 'underscore';
import UpdatePrenoticeShipmentStatusModal from '../shipments/UpdatePrenoticeShipmentStatusModal';
import BulkShipmentBridges from '../shipments/BulkShipmentBridges';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';

function BulkActionsDropdown({
  view,
  disabled,
  arrivedActionDisabled,
  changeShipperDisabled,
  changeCarrierDisabled,
  selectedShipmentsForAccessorials,
  selectedShipmentsForYards,
  selectedShipments,
  selectedRows,
  onBillingStatusPendingReviewUpdate,
  bulkUploadDocumentsDisabled,
  isSameShipperOrMasterShipper,
}) {
  const { t } = useTranslation();
  const [bulkAction, setBulkAction] = useState('');
  const [brokerCarrierDriver, setBrokerCarrierDriver] = useState();
  const {
    visible: changeShipperModalVisible,
    show: showChangeShipperModal,
    close: closeChangeShipperModal,
  } = useModal();

  const {
    visible: changeCarrierModalVisible,
    show: showChangeCarrierModal,
    close: closeChangeCarrierModal,
  } = useModal();

  const {
    visible: assignDriverModalVisible,
    show: showAssignDriverModal,
    close: closeAssignDriverModal,
  } = useModal();

  const {
    visible: confirmAssignCarrierModalVisible,
    show: showConfirmAssignCarrierModal,
    close: closeConfirmAssignCarrierModal,
  } = useModal();

  const {
    visible: changeConsigneeModalVisible,
    show: showChangeConsigneeModal,
    close: closeChangeConsigneeModal,
  } = useModal();

  const {
    visible: bulkAddAccessorialModalVisible,
    show: showBulkAddAccessorialModal,
    close: closeBulkAddAccessorialModal,
  } = useModal();

  const {
    visible: bulkUpdateCarrierCostModalVisible,
    show: showBulkUpdateCarrierCostModal,
    close: closeBulkUpdateCarrierCostModal,
  } = useModal();

  const {
    visible: bulkUpdateSendDOModalVisible,
    show: showBulkUpdateSendDOModal,
    close: closeBulkUpdateSendDOModal,
  } = useModal();

  const {
    visible: bulkBOLGenerationModalVisible,
    show: showBulkBOLGenerationModal,
    close: closeBulkBOLGenerationModal,
  } = useModal();

  const {
    visible: sendRateConfirmationModalVisible,
    show: showSendRateConfirmationModal,
    close: closeSendRateConfirmationModal,
  } = useModal();

  const {
    visible: bulkAddYardsModalVisible,
    show: showBulkAddYardsModal,
    close: closeBulkAddYardsModal,
  } = useModal();

  const {
    visible: evaluateBillingStatusConfirmationModalVisible,
    show: showEvaluateBillingStatusConfirmationModal,
    close: closeEvaluateBillingStatusConfirmationModal,
  } = useModal();

  const {
    visible: bulkEditModalVisible,
    show: showBulkEditModal,
    close: closeBulkEditModal,
  } = useModal();

  const {
    visible: bulkCloseModalVisible,
    show: showBulkCloseModal,
    close: closeBulkCloseModal,
  } = useModal();

  const {
    visible: overrideBillingStatusModalVisible,
    show: showOverrideBillingStatusModal,
    close: closeOverrideBillingStatusModal,
  } = useModal();

  const {
    visible: markBillingStatusPendingReviewModalVisible,
    show: showMarkBillingStatusPendingReviewModalVisible,
    close: closeMarkBillingStatusPendingReviewModal,
  } = useModal();

  const {
    visible: bulkUploadDocumentsModalVisible,
    show: showBulkUploadDocumentsModalVisible,
    close: closeBulkUploadDocumentsModalVisible,
  } = useModal();

  const {
    visible: bulkAddBridgeCodesModalVisible,
    show: showBulkAddBridgeCodesModalVisible,
    close: closeBulkAddBridgeCodesModalVisible,
  } = useModal();

  const {
    visible: bulkUpdatePrenoticeShipmentsModalVisible,
    show: showBulkUpdatePrenoticeShipmentsModalVisible,
    close: closeBulkUpdatePrenoticeShipmentsModalVisible,
  } = useModal();

  const handlePendingReviewModalUpdate = (updates) => {
    closeMarkBillingStatusPendingReviewModal();
    onBillingStatusPendingReviewUpdate(updates);
  };

  const handleBulkAction = (bulkAction) => {
    const {
      CHANGE_SHIPPER,
      CHANGE_CARRIER,
      ASSIGN_DRIVER,
      UPDATE_CARRIER_COST,
      SEND_DELIVERY_ORDER,
      BULK_ACCESSORIAL,
      SEND_BILL_OF_LADING,
      CHANGE_CONSIGNEE,
      SEND_RATE_CONFIRMATION,
      ADD_YARDS_IN_BULK,
      EVALUATE_BILLING_STATUS,
      CLOSE_SHIPMENT,
      OVERRIDE_BILLING_STATUS,
      MARK_BILLING_STATUS_PENDING_REVIEW,
      BULK_UPLOAD_DOCUMENTS,
      UPDATE_PRENOTICE_TO_FINAL,
      UPDATE_FINAL_TO_PRENOTICE,
      BULK_ADD_BRIDGE_CODES,
    } = massUpdateActions;
    switch (bulkAction) {
      case CHANGE_SHIPPER:
        showChangeShipperModal();
        break;
      case CHANGE_CARRIER:
        showChangeCarrierModal();
        break;
      case SEND_DELIVERY_ORDER:
        showBulkUpdateSendDOModal();
        break;
      case UPDATE_CARRIER_COST:
        showBulkUpdateCarrierCostModal();
        break;
      case BULK_ACCESSORIAL:
        showBulkAddAccessorialModal();
        break;
      case SEND_BILL_OF_LADING:
        showBulkBOLGenerationModal();
        break;
      case CHANGE_CONSIGNEE:
        showChangeConsigneeModal();
        break;
      case SEND_RATE_CONFIRMATION:
        showSendRateConfirmationModal();
        break;
      case ADD_YARDS_IN_BULK:
        showBulkAddYardsModal();
        break;
      case EVALUATE_BILLING_STATUS:
        showEvaluateBillingStatusConfirmationModal();
        break;
      case CLOSE_SHIPMENT:
        showBulkCloseModal();
        break;
      case OVERRIDE_BILLING_STATUS:
        showOverrideBillingStatusModal();
        break;
      case MARK_BILLING_STATUS_PENDING_REVIEW:
        showMarkBillingStatusPendingReviewModalVisible();
        break;
      case ASSIGN_DRIVER:
        showAssignDriverModal();
        break;
      case BULK_UPLOAD_DOCUMENTS:
        showBulkUploadDocumentsModalVisible();
        break;
      case BULK_ADD_BRIDGE_CODES:
        showBulkAddBridgeCodesModalVisible();
        break;
      case UPDATE_PRENOTICE_TO_FINAL:
      case UPDATE_FINAL_TO_PRENOTICE:
        showBulkUpdatePrenoticeShipmentsModalVisible();
        break;
      default:
        setBulkAction(bulkAction);
        showBulkEditModal();
        break;
    }
  };

  const notDrayage = view !== 'drayage';
  const overrideBillingStatusEnabled = SessionStore.isBillingStatusAdmin();
  const canChangeBillingStatus =
    SessionStore.isBillingStatusAdmin() ||
    SessionStore.isBillingStatusManager();
  const billingStatusPendingReviewEnabled =
    canChangeBillingStatus || SessionStore.isBillingStatusUser();
  const allArePreArrivalShipments = (selectedRows || [])?.every(
    (s) => s?.pre_arrival_shipment,
  );
  const disableFinalToPrenotice =
    !allArePreArrivalShipments ||
    selectedRows.some(
      (s) =>
        s?.shipment_pre_arrival_status !== 'final' &&
        s?.shipment_pre_arrival_status !== 'converted_final',
    );
  const disablePrenoticeToFinal =
    !allArePreArrivalShipments ||
    selectedRows.some((s) => s?.shipment_pre_arrival_status !== 'pre_notice');

  const showBillingStatusToggle = useMemo(() => {
    return (
      canChangeBillingStatus &&
      selectedRows.length > 0 &&
      selectedRows.every((item) => {
        return (
          item.billing_status_state_billing_status === PENDING_REVIEW &&
          (item
            .billing_status_state_pause_automated_billing_evaluation_reason_codes
            ?.length ?? 0) === 0
        );
      })
    );
  }, [selectedRows, canChangeBillingStatus]);

  return (
    <>
      <DropdownMenu
        dataTestId="DropdownMenu-d909fd8e"
        id="bulk-actions-dropdown"
        title={t('ACTIONS')}
        disabled={disabled}
        className={`mr-2 ${disabled ? 'disabled' : ''}`}
      >
        {!isProd() && (
          <Menu.Item data-testid="MenuItem-09989fbd" key="add_yards_in_bulk">
            <DropdownItem
              dataTestId="addYardsInBulkButton"
              disabled={notDrayage || !selectedShipmentsForYards.length}
              onClick={() =>
                handleBulkAction(massUpdateActions.ADD_YARDS_IN_BULK)
              }
            >
              {t('ADD_YARDS_IN_BULK')}
            </DropdownItem>
          </Menu.Item>
        )}
        <Menu.Item data-testid="MenuItem-a076c36d" key="change_driver">
          <DropdownItem
            dataTestId="assignDriverButton"
            disabled={changeCarrierDisabled}
            onClick={() => handleBulkAction(massUpdateActions.ASSIGN_DRIVER)}
          >
            {t('ASSIGN_DRIVER')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-a076c35d" key="change_carrier">
          <DropdownItem
            dataTestId="changeCarrierButton"
            disabled={changeCarrierDisabled}
            onClick={() => handleBulkAction(massUpdateActions.CHANGE_CARRIER)}
          >
            {t('ASSIGN_CARRIER')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-34492be5" key="bulk_accessorial">
          <DropdownItem
            dataTestId="bulkAccessorialButton"
            onClick={() => handleBulkAction(massUpdateActions.BULK_ACCESSORIAL)}
          >
            {t('BULK_ACCESSORIALS')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-5c6c2eba" key="bulk_apply_admin_notes">
          <DropdownItem
            dataTestId="bulkApplyNotesButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.BULK_APPLY_ADMIN_NOTES)
            }
          >
            {firstLetterTitlization(t('BULK_APPLY_ADMIN_NOTES'))}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-5c6c2ebb" key="bulk_apply_special_instructions">
          <DropdownItem
            dataTestId="bulkApplySpecialInstructionsButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.BULK_APPLY_SPECIAL_INSTRUCTIONS)
            }
          >
            {firstLetterTitlization(t('BULK_APPLY_SPECIAL_INSTRUCTIONS'))}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-5c6c2eua" key="bulk_add_tags">
          <DropdownItem
            dataTestId="bulkAddTagsButton"
            onClick={() => handleBulkAction(massUpdateActions.BULK_ADD_TAGS)}
          >
            {firstLetterTitlization(t('BULK_ADD_TAGS'))}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-5c6c2eby" key="bulk_clear_tags">
          <DropdownItem
            dataTestId="bulkClearTags"
            onClick={() => handleBulkAction(massUpdateActions.BULK_CLEAR_TAGS)}
          >
            {firstLetterTitlization(t('BULK_CLEAR_TAGS'))}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item
          data-testid="MenuItem-5c6c2gby"
          key="bulk_add_reference_numbers"
        >
          <DropdownItem
            disabled={!isSameShipperOrMasterShipper}
            dataTestId="bulkAddRefNumbers"
            onClick={() =>
              handleBulkAction(massUpdateActions.BULK_ADD_REFERENCE_NUMBERS)
            }
          >
            {firstLetterTitlization(t('BULK_ADD_REFERENCE_NUMBERS'))}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item
          data-testid="MenuItem-32f6f680"
          key="evaluate_billing_status"
        >
          <DropdownItem
            dataTestId="evaluateBillingStatusButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.EVALUATE_BILLING_STATUS)
            }
          >
            {t('EVALUATE_BILLING_STATUS')}
          </DropdownItem>
        </Menu.Item>
        <AuthorizationWrapper excludedRegions={REGIONS.AP}>
          <Menu.Item data-testid="MenuItem-e2020223" key="change_consignee">
            <DropdownItem
              dataTestId="changeConsigneeButton"
              disabled={notDrayage}
              onClick={() =>
                handleBulkAction(massUpdateActions.CHANGE_CONSIGNEE)
              }
            >
              {t('CHANGE_CONSIGNEE')}
            </DropdownItem>
          </Menu.Item>
        </AuthorizationWrapper>
        <Menu.Item data-testid="MenuItem-d1160359" key="change_shipper">
          <DropdownItem
            dataTestId="changeShipperButton"
            disabled={changeShipperDisabled}
            onClick={() => handleBulkAction(massUpdateActions.CHANGE_SHIPPER)}
          >
            {t('CHANGE_SHIPPER')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-33f4c555" key="complete_stop">
          <DropdownItem
            dataTestId="completeStopButton"
            onClick={() => handleBulkAction(massUpdateActions.COMPLETE_STOP)}
          >
            {t('COMPLETE_STOP')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-29266a5f" key="send_bill_of_lading">
          <DropdownItem
            dataTestId="sendBillOfLadingButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.SEND_BILL_OF_LADING)
            }
          >
            {t('SEND_BILL_OF_LADING')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-3b01b02d" key="send_delivery_order">
          <DropdownItem
            dataTestId="sendDeliveryOrderButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.SEND_DELIVERY_ORDER)
            }
          >
            {t('SEND_DO')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-366a6a49" key="send_rate_confirmation">
          <DropdownItem
            dataTestId="sendRateConfirmationButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.SEND_RATE_CONFIRMATION)
            }
          >
            {t('SEND_RATE_CONFIRMATION')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-0cdd683c" key="edit_arrival">
          <DropdownItem
            dataTestId="editArrivalButton"
            disabled={arrivedActionDisabled}
            onClick={() => handleBulkAction(massUpdateActions.EDIT_ARRIVAL)}
          >
            {t('UPDATE_ARRIVAL')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-ca7a768a" key="update_appointment">
          <DropdownItem
            dataTestId="updateAppointmentButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_APPOINTMENT_WINDOW)
            }
          >
            {t('UPDATE_APPOINTMENT_WINDOW')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-0977bdbb" key="update_carrier_cost">
          <DropdownItem
            dataTestId="updateCarrierCostButton"
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_CARRIER_COST)
            }
          >
            {firstLetterTitlization(t('UPDATE_CARRIER_COST'))}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-db3da465" key="edit_discharge">
          <DropdownItem
            dataTestId="editDischargeButton"
            disabled={notDrayage}
            onClick={() => handleBulkAction(massUpdateActions.EDIT_DISCHARGE)}
          >
            {t('UPDATE_DISCHARGE')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item
          data-testid="MenuItem-12c5d150"
          key="update_earliest_get_empty"
        >
          <DropdownItem
            dataTestId="updateEarliestGetEmptyButton"
            disabled={notDrayage}
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_EARLIEST_GET_EMPTY)
            }
          >
            {t('UPDATE_EARLIEST_EMPTY')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item
          data-testid="MenuItem-12c5d151"
          key="update_empty_ready_for_pickup"
        >
          <DropdownItem
            dataTestId="updateEmptyReadyForPickupButton"
            disabled={notDrayage}
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_EMPTY_READY_FOR_PICKUP)
            }
          >
            {t('UPDATE_EMPTY_READY_FOR_PICKUP')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-97846598" key="update_earliest_return">
          <DropdownItem
            dataTestId="updateEarliestReturnButton"
            disabled={notDrayage}
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_EARLIEST_RETURN)
            }
          >
            {t('UPDATE_EARLIEST_RETURN')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-b7bed4ae" key="edit_estimated_arrival">
          <DropdownItem
            dataTestId="editEstimatedArrivalButton"
            disabled={notDrayage}
            onClick={() =>
              handleBulkAction(massUpdateActions.EDIT_ESTIMATED_ARRIVAL)
            }
          >
            {t('UPDATE_ETA')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item
          data-testid="MenuItem-ac2a4abe"
          key="update_empty_returned_date"
        >
          <DropdownItem
            dataTestId="updateEmptyReturnedDateButton"
            disabled={notDrayage}
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_EMPTY_RETURN)
            }
          >
            {t('UPDATE_EMPTY_RETURN')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-9b665af4" key="update_last_cut">
          <DropdownItem
            dataTestId="updateLastCutButton"
            disabled={notDrayage}
            onClick={() => handleBulkAction(massUpdateActions.UPDATE_LAST_CUT)}
          >
            {t('UPDATE_LAST_CUT_DATE')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-8feca621" key="edit_last_free_day">
          <DropdownItem
            dataTestId="editLastFreeDayButton"
            disabled={notDrayage}
            onClick={() =>
              handleBulkAction(massUpdateActions.EDIT_LAST_FREE_DAY)
            }
          >
            {t('UPDATE_TERMINAL_LFD')}
          </DropdownItem>
        </Menu.Item>
        {featureEnabled(CONFIGURED_FEATURES.AMAZON_PRE_ARRIVAL) && (
          <Menu.Item
            data-testid="MenuItem-8fecd621"
            key="update_prenotice_to_final"
          >
            <DropdownItem
              dataTestId="updatePrenoticeToFinal"
              disabled={disablePrenoticeToFinal}
              disabledText={t('SHIPMENTS_NOT_ELIGIBLE_MSG')}
              onClick={() =>
                handleBulkAction(massUpdateActions.UPDATE_PRENOTICE_TO_FINAL)
              }
            >
              {t('UPDATE_PRENOTICE_TO_FINAL')}
            </DropdownItem>
          </Menu.Item>
        )}
        {featureEnabled(CONFIGURED_FEATURES.AMAZON_PRE_ARRIVAL) && (
          <Menu.Item
            data-testid="MenuItem-8fece621"
            key="update_final_to_prenotice"
          >
            <DropdownItem
              dataTestId="updateFinalToPrenotice"
              disabled={disableFinalToPrenotice}
              disabledText={t('SHIPMENTS_NOT_ELIGIBLE_MSG')}
              onClick={() =>
                handleBulkAction(massUpdateActions.UPDATE_FINAL_TO_PRENOTICE)
              }
            >
              {t('UPDATE_FINAL_TO_PRENOTICE')}
            </DropdownItem>
          </Menu.Item>
        )}

        <Menu.Item
          data-testid="MenuItem-8fada621"
          key="update_eta_to_final_rail_facility"
        >
          <DropdownItem
            dataTestId="updateEtaToFinalRailFacility"
            onClick={() =>
              handleBulkAction(
                massUpdateActions.EDIT_ETA_TO_FINAL_RAIL_FACILITY,
              )
            }
          >
            {t('ETA_TO_FINAL_RAIL_FACILITY')}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-7fdda521" key="update_rail_lfd">
          <DropdownItem
            dataTestId="updateRailLfd"
            onClick={() =>
              handleBulkAction(massUpdateActions.EDIT_LFD_AT_RAIL_FACILITY)
            }
          >
            {t('RAIL_LFD_ACTION')}
          </DropdownItem>
        </Menu.Item>
        {SessionStore.isShipmentClosureAdmin() && (
          <Menu.Item data-testid="MenuItem-eb8782a0" key="close_shipment">
            <DropdownItem
              dataTestId="closeShipment"
              disabled={notDrayage}
              onClick={() => handleBulkAction(massUpdateActions.CLOSE_SHIPMENT)}
            >
              {t('CLOSE_SHIPMENT')}
            </DropdownItem>
          </Menu.Item>
        )}
        {overrideBillingStatusEnabled && (
          <Menu.Item
            data-testid="MenuItem-f4e71ec4"
            key="override_billing_status"
          >
            <DropdownItem
              dataTestId="overrideBillingStatus"
              disabled={notDrayage}
              onClick={() =>
                handleBulkAction(massUpdateActions.OVERRIDE_BILLING_STATUS)
              }
            >
              {t('OVERRIDE_BILLING_STATUS')}
            </DropdownItem>
          </Menu.Item>
        )}
        {billingStatusPendingReviewEnabled && (
          <Menu.Item key="markBillingStatusPendingReview">
            <DropdownItem
              dataTestId="markBillingStatusPendingReview"
              disabled={notDrayage}
              onClick={() =>
                handleBulkAction(
                  massUpdateActions.MARK_BILLING_STATUS_PENDING_REVIEW,
                )
              }
            >
              {t('MARK_BILLING_STATUS_PENDING_REVIEW')}
            </DropdownItem>
          </Menu.Item>
        )}
        <Menu.Item data-testid="MenuItem-f3a809e7" key="update_review_date">
          <DropdownItem
            dataTestId="updateReviewDate"
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_REVIEW_DATE)
            }
          >
            {`${t('UPDATE')} ${t('REVIEW_DATE')}`}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item
          data-testid="MenuItem-02195f54"
          key="update_accounting_review_date"
        >
          <DropdownItem
            dataTestId="updateAccountingReviewDate"
            onClick={() =>
              handleBulkAction(massUpdateActions.UPDATE_ACCOUNTING_REVIEW_DATE)
            }
          >
            {`${t('UPDATE')} ${t('ACCOUNTING_REVIEW_DATE')}`}
          </DropdownItem>
        </Menu.Item>
        <Menu.Item data-testid="MenuItem-02195fko" key="bulk_upload_documents">
          <DropdownItem
            dataTestId="bulkUploadDocuments"
            disabled={bulkUploadDocumentsDisabled}
            disabledText={t('BULK_UPLOAD_DISABLED_DOCUMENTS_MESSAGE')}
            onClick={() =>
              handleBulkAction(massUpdateActions.BULK_UPLOAD_DOCUMENTS)
            }
          >
            {t('BULK_UPLOAD_DOCUMENTS')}
          </DropdownItem>
        </Menu.Item>
        {!notDrayage &&
          featureEnabled(CONFIGURED_FEATURES.BULK_MARKET_EXCEPTIONS) && (
            <Menu.Item
              data-testid="MenuItem-02195nKumar"
              key="bulk_add_bridge_codes"
            >
              <DropdownItem
                dataTestId="bulkAddBridgeCodes"
                onClick={() =>
                  handleBulkAction(massUpdateActions.BULK_ADD_BRIDGE_CODES)
                }
              >
                {t('BULK_ADD_BRIDGE_CODES')}
              </DropdownItem>
            </Menu.Item>
          )}
        {!notDrayage && (
          <Menu.Item
            data-testid="MenuItem-02195lSingh"
            key="bulk_add_terminal_holds"
          >
            <DropdownItem
              dataTestId="bulkAddTerminalHolds"
              onClick={() =>
                handleBulkAction(massUpdateActions.BULK_ADD_TERMINAL_HOLDS)
              }
            >
              {t('BULK_ADD_TERMINAL_HOLDS')}
            </DropdownItem>
          </Menu.Item>
        )}
      </DropdownMenu>
      {bulkAddBridgeCodesModalVisible && (
        <BulkShipmentBridges
          isOpen={bulkAddBridgeCodesModalVisible}
          shipments={selectedRows.map((j) => ({
            shipper: {
              id: j.shipper_oid || undefined,
            },
            ...j,
          }))}
          onClose={closeBulkAddBridgeCodesModalVisible}
        />
      )}
      {bulkUploadDocumentsModalVisible && (
        <BulkUploadDocumentsModel
          isOpen={bulkUploadDocumentsModalVisible}
          shipments={selectedRows.map((j) => ({
            shipper: {
              id: j.shipper_oid || undefined,
            },
            ...j,
          }))}
          onClose={closeBulkUploadDocumentsModalVisible}
        />
      )}
      {bulkEditModalVisible && (
        <BulkEditModal
          show
          action={bulkAction}
          onHide={closeBulkEditModal}
          shipments={selectedShipments}
        />
      )}
      {changeShipperModalVisible && (
        <ChangeUserModal
          jobs={selectedRows}
          show={changeShipperModalVisible}
          type="shipper"
          onSave={(shipper, selectedJobs) =>
            ShipmentsActionCreators.updateShipper(shipper, selectedJobs)
          }
          onHide={closeChangeShipperModal}
        />
      )}
      {assignDriverModalVisible && (
        <AssignDriverModal
          shipments={selectedRows.map((j) => ({
            shipper: {
              id: j.shipper_oid || undefined,
            },
            ...j,
          }))}
          shipment={_.first(selectedRows)}
          show={showAssignDriverModal}
          showDrayageSelectionForShorthaul
          hideDriverSuggestions
          onAssignDriver={(shipments, user) => {
            let userId = '';
            if (user?._type === 'Driver') {
              userId = user?._id;
            } else {
              userId = user?.default_driver;
            }
            ShipmentsActionCreators.bulkAssignDriver(userId, shipments);
          }}
          onHide={closeAssignDriverModal}
        />
      )}
      {changeCarrierModalVisible && (
        <ChangeUserModal
          jobs={selectedRows.map((j) => ({
            shipper: {
              id: j.shipper_oid || undefined,
            },
            ...j,
          }))}
          show={changeCarrierModalVisible}
          type="carrier"
          onSave={(carrier, selectedJobs) =>
            ShipmentsActionCreators.updateCarrier(carrier, selectedJobs)
          }
          onAssignBrokerCarrier={(_shipment, driver) => {
            closeChangeCarrierModal();
            setBrokerCarrierDriver(driver);
            showConfirmAssignCarrierModal();
          }}
          onHide={closeChangeCarrierModal}
        />
      )}
      <ConfirmAssignCarrierModal
        isOpen={confirmAssignCarrierModalVisible}
        brokerCarrierDriver={brokerCarrierDriver}
        shipment={selectedRows.map((j) => ({
          shipper: {
            id: j.shipper_oid || undefined,
          },
          ...j,
        }))}
        onConfirm={(shipments, carrier) => {
          ShipmentsActionCreators.updateCarrier(carrier, shipments);
          closeConfirmAssignCarrierModal();
        }}
        onClose={closeConfirmAssignCarrierModal}
      />
      {changeConsigneeModalVisible && (
        <ChangeUserModal
          jobs={selectedRows}
          show={changeConsigneeModalVisible}
          type="consignee"
          onSave={(consignee, selectedJobs) =>
            ShipmentsActionCreators.updateConsignee(consignee, selectedJobs)
          }
          onHide={closeChangeConsigneeModal}
        />
      )}
      {bulkAddAccessorialModalVisible && (
        <BulkAddAccessorialsModal
          orderId={null}
          show={bulkAddAccessorialModalVisible}
          shipmentIds={(selectedShipmentsForAccessorials || []).map(
            (s) => s._id,
          )}
          onHide={closeBulkAddAccessorialModal}
          edit={false}
        />
      )}
      {bulkUpdateCarrierCostModalVisible && (
        <BulkUpdateCarrierCostModal
          show={bulkUpdateCarrierCostModalVisible}
          shipments={selectedShipments}
          onHide={closeBulkUpdateCarrierCostModal}
        />
      )}
      {bulkUpdateSendDOModalVisible && (
        <BulkUpdateSendDOModal
          title={t('SEND_DELIVERY_ORDER')}
          send_do
          show={bulkUpdateSendDOModalVisible}
          shipments={selectedShipments}
          onHide={closeBulkUpdateSendDOModal}
        />
      )}
      {bulkBOLGenerationModalVisible && (
        <BulkBOLGenerationModal
          shipments={selectedShipments}
          onHide={closeBulkBOLGenerationModal}
        />
      )}
      {sendRateConfirmationModalVisible && (
        <BulkGenerateRateConfirmation
          showModal={sendRateConfirmationModalVisible}
          selectedShipments={selectedShipments}
          onHide={closeSendRateConfirmationModal}
        />
      )}
      {bulkAddYardsModalVisible && (
        <BulkAddYardsModal
          showModal={bulkAddYardsModalVisible}
          selectedShipmentsData={selectedShipmentsForYards}
          onHide={closeBulkAddYardsModal}
        />
      )}
      {evaluateBillingStatusConfirmationModalVisible && (
        <ConfirmationModal
          dataTestId="ConfirmationModal-d70ec431"
          open={evaluateBillingStatusConfirmationModalVisible}
          onHide={closeEvaluateBillingStatusConfirmationModal}
          title={t('EVALUATE_BILLING_STATUS')}
          description={t('EVALUATE_BILLING_STATUS_CONFIRMATION', {
            count: selectedShipments.length,
          })}
          onConfirm={async () => {
            try {
              await evaluateBillingStatus(selectedShipments);
              showToast(t('EVALUATE_BILLING_STATUS_SUCCESS'));
            } catch (e) {
              console.error(e);
              showToast(t('EVALUATE_BILLING_STATUS_FAILED'), '', 'error');
            }
          }}
        />
      )}
      {bulkCloseModalVisible && (
        <ConfirmationModal
          dataTestId="ConfirmationModal-39916d90"
          open={bulkCloseModalVisible}
          title={t('CLOSE_SHIPMENT')}
          description={
            <Alert className="mt-4">
              This will by-pass all workflows; are you sure you want to close
              these shipments?
            </Alert>
          }
          onHide={closeBulkCloseModal}
          onConfirm={async () => {
            try {
              const res = await bulkCloseJobs(
                selectedRows.map((row) => row.id),
              );
              const hasErrors = Object.values(res?.entity?.results).some(
                (res) => res.isError,
              );
              const hasSuccesses = Object.values(res?.entity?.results).some(
                (res) => !res.isError,
              );
              if (hasErrors) {
                showToast(
                  'There were some shipment close failures',
                  '',
                  'error',
                );
              } else if (hasSuccesses) {
                showToast(
                  'The selected shipments have been closed successfully!',
                );
              }
            } catch (e) {
              console.error(e);
              showToast(
                'There were problems closing your shipments',
                '',
                'error',
              );
            }
          }}
        />
      )}
      {overrideBillingStatusEnabled && overrideBillingStatusModalVisible && (
        <OverrideBillingStatusModal
          shipmentIds={selectedShipments}
          open={overrideBillingStatusModalVisible}
          onHide={closeOverrideBillingStatusModal}
        />
      )}
      {billingStatusPendingReviewEnabled &&
        markBillingStatusPendingReviewModalVisible && (
          <BillingStatusPendingReviewModal
            shipmentIds={selectedShipments}
            showStatusToggle={showBillingStatusToggle}
            reasonCodes={
              showBillingStatusToggle
                ? selectedRows?.[0]
                    ?.billing_status_state_pause_automated_billing_evaluation_reason_codes
                : []
            }
            note={
              showBillingStatusToggle
                ? selectedRows?.[0]
                    ?.billing_status_state_pause_automated_billing_evaluation_reason_code
                : ''
            }
            open={markBillingStatusPendingReviewModalVisible}
            onHide={closeMarkBillingStatusPendingReviewModal}
            onSuccess={handlePendingReviewModalUpdate}
          />
        )}
      {bulkUpdatePrenoticeShipmentsModalVisible && (
        <UpdatePrenoticeShipmentStatusModal
          status={
            selectedRows.every(
              (s) =>
                s?.shipment_pre_arrival_status === 'final' ||
                s?.shipment_pre_arrival_status === 'converted_final',
            )
              ? 'pre_arrival'
              : 'final'
          }
          orders={_.uniq(selectedRows?.map((s) => s?.order_oid))}
          shipmentCount={(selectedRows || []).length}
          open={bulkUpdatePrenoticeShipmentsModalVisible}
          onHide={closeBulkUpdatePrenoticeShipmentsModalVisible}
        />
      )}
    </>
  );
}

export default BulkActionsDropdown;
